jQuery(function ($) {
  "use strict";

  /*
  |--------------------------------------------------------------------------
  | TRANSLATION HELPERS
  |--------------------------------------------------------------------------
  */

  function t(key, replacements = {}) {
    let text = key;

    if (
      typeof AevonWorkspace !== "undefined" &&
      AevonWorkspace.i18n &&
      typeof AevonWorkspace.i18n[key] === "string"
    ) {
      text = AevonWorkspace.i18n[key];
    }

    Object.keys(replacements).forEach(function (replacementKey) {
      text = text
        .split(":" + replacementKey)
        .join(String(replacements[replacementKey]));
    });

    return text;
  }

  function escapeHtml(value) {
    return $("<div>")
      .text(String(value || ""))
      .html();
  }

  /*
  |--------------------------------------------------------------------------
  | GLOBAL UI HELPERS
  |--------------------------------------------------------------------------
  */

  function showToast(message, type = "error") {
    let $toast = $("#aevon-toast");

    if (!$toast.length) {
      $("body").append(`
        <div
          id="aevon-toast"
          class="fixed right-6 top-6 z-[9999] hidden max-w-md rounded-2xl border bg-white p-5 shadow-2xl">

          <div
            id="aevon-toast-title"
            class="text-sm font-bold">
          </div>

          <div
            id="aevon-toast-message"
            class="mt-1 text-sm text-slate-700">
          </div>
        </div>
      `);

      $toast = $("#aevon-toast");
    }

    const isSuccess = type === "success";

    $toast
      .stop(true, true)
      .removeClass("border-red-200 border-green-200")
      .addClass(isSuccess ? "border-green-200" : "border-red-200");

    $("#aevon-toast-title")
      .removeClass("text-red-600 text-green-600")
      .addClass(isSuccess ? "text-green-600" : "text-red-600")
      .text(isSuccess ? t("js.toast.success") : t("js.toast.error"));

    $("#aevon-toast-message").text(message || t("js.error.unexpected"));

    $toast.removeClass("hidden").hide().fadeIn(150);

    setTimeout(function () {
      $toast.fadeOut(200, function () {
        $toast.addClass("hidden");
      });
    }, 6000);
  }

  function openModal(selector) {
    $(selector).removeClass("hidden").addClass("flex");
  }

  function closeModal(selector) {
    $(selector).removeClass("flex").addClass("hidden");
  }

  function getResponseMessage(response, fallback) {
    if (response && response.data && response.data.message) {
      return response.data.message;
    }

    return fallback;
  }

  function getAjaxErrorMessage(xhr, fallback = t("js.error.ajax")) {
    if (
      xhr &&
      xhr.responseJSON &&
      xhr.responseJSON.data &&
      xhr.responseJSON.data.message
    ) {
      return xhr.responseJSON.data.message;
    }

    return fallback;
  }

  /*
  |--------------------------------------------------------------------------
  | GENERIC FORM SUBMIT
  |--------------------------------------------------------------------------
  |
  | Used for standard forms without file uploads.
  | serialize() automatically supports partner_companies[].
  |
  */

  function ajaxSubmit($form, action, errorMessage) {
    const $button = $form.find('button[type="submit"]');

    const originalButtonHtml = $button.html();

    $button.prop("disabled", true).addClass("cursor-not-allowed opacity-60");

    $.ajax({
      url: AevonWorkspace.ajaxUrl,
      method: "POST",

      data:
        $form.serialize() +
        "&action=" +
        encodeURIComponent(action) +
        "&nonce=" +
        encodeURIComponent(AevonWorkspace.nonce),

      success: function (response) {
        if (!response.success) {
          showToast(getResponseMessage(response, errorMessage));

          return;
        }

        showToast(
          getResponseMessage(response, t("js.changes_saved")),
          "success",
        );

        setTimeout(function () {
          window.location.reload();
        }, 500);
      },

      error: function (xhr) {
        showToast(getAjaxErrorMessage(xhr, t("js.error.request_failed")));
      },

      complete: function () {
        $button
          .prop("disabled", false)
          .removeClass("cursor-not-allowed opacity-60")
          .html(originalButtonHtml);
      },
    });
  }

  /*
  |--------------------------------------------------------------------------
  | DASHBOARD ISSUES PANEL
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "#aevon-toggle-issues", function () {
    $("#aevon-issues-panel").slideToggle(180);
  });

  /*
  |--------------------------------------------------------------------------
  | CONFIRMATION MODAL
  |--------------------------------------------------------------------------
  */

  let confirmCallback = null;

  function showConfirm(title, html, callback) {
    $("#confirm-modal-title").text(title);
    $("#confirm-modal-text").html(html);

    confirmCallback = callback;

    openModal("#confirm-modal");
  }

  $("#confirm-modal-cancel").on("click", function () {
    closeModal("#confirm-modal");
    confirmCallback = null;
  });

  $("#confirm-modal-confirm").on("click", function () {
    closeModal("#confirm-modal");

    if (typeof confirmCallback === "function") {
      confirmCallback();
    }

    confirmCallback = null;
  });

  /*
  |--------------------------------------------------------------------------
  | NORMALIZE CHECKBOX VALUES
  |--------------------------------------------------------------------------
  */

  function isCheckedValue(value) {
    return (
      value === true ||
      value === 1 ||
      value === "1" ||
      value === "true" ||
      value === "yes" ||
      value === "on"
    );
  }

  /*
  |--------------------------------------------------------------------------
  | ASSIGNMENT MODAL — FORM STATE
  |--------------------------------------------------------------------------
  */

  function updateAssignmentModalState(options = {}) {
    const preserveValues = options.preserveValues === true;

    const $form = $("#aevon-assignment-form");

    const $status = $form.find('[name="status"]');

    const $worksite = $form.find('[name="worksite_id"]');

    const $accommodation = $form.find('[name="accommodation_id"]');

    const $room = $form.find('[name="room"]');

    const $checkIn = $form.find('[name="check_in"]');

    const $checkOut = $form.find('[name="check_out"]');

    const $worksiteSection = $form.find("[data-assignment-worksite-section]");

    const $accommodationSection = $form.find(
      "[data-assignment-accommodation-section]",
    );

    const status = $status.val();

    const isAssigned = status === "assigned";

    /*
     * Worksite and accommodation are used only
     * for assignments with the assigned status.
     */
    $worksiteSection.toggleClass("hidden", !isAssigned);

    $accommodationSection.toggleClass("hidden", !isAssigned);

    $worksite.prop("required", isAssigned);

    $worksite.prop("disabled", !isAssigned);

    $accommodation.prop("disabled", !isAssigned);

    $room.prop("disabled", !isAssigned);

    $checkIn.prop("disabled", !isAssigned);

    $checkOut.prop("disabled", !isAssigned);

    if (!isAssigned) {
      hideAssignmentWorksiteDetails();

      if (!preserveValues) {
        $worksite.val("");

        $accommodation.val("").trigger("change");

        $room.val("");
        $checkIn.val("");
        $checkOut.val("");
      }

      return;
    }

    updateAssignmentWorksiteState();
  }

  /*
  |--------------------------------------------------------------------------
  | ASSIGNMENT MODAL — HIDE WORKSITE DETAILS
  |--------------------------------------------------------------------------
  */

  function hideAssignmentWorksiteDetails() {
    const $form = $("#aevon-assignment-form");

    $form.find("[data-assignment-supervisor-notice]").addClass("hidden");

    $form.find("[data-assignment-supervisor-missing]").addClass("hidden");

    $form.find("[data-assignment-project-notice]").addClass("hidden");

    $form.find("[data-assignment-supervisor-name]").text("—");

    $form.find("[data-assignment-project-company-name]").text("");
  }

  /*
  |--------------------------------------------------------------------------
  | ASSIGNMENT MODAL — WORKSITE STATE
  |--------------------------------------------------------------------------
  */

  function updateAssignmentWorksiteState() {
    const $form = $("#aevon-assignment-form");

    const $worksite = $form.find('[name="worksite_id"]');

    const $selectedWorksite = $worksite.find("option:selected");

    const worksiteId = String($worksite.val() || "");

    const supervisorName = String(
      $selectedWorksite.data("supervisor-name") || "",
    ).trim();

    const isPartnerWorksite =
      String($selectedWorksite.data("partner-worksite") || "0") === "1";

    const projectCompanyName = String(
      $selectedWorksite.data("owner-company-name") || "",
    ).trim();

    const $supervisorNotice = $form.find("[data-assignment-supervisor-notice]");

    const $supervisorMissing = $form.find(
      "[data-assignment-supervisor-missing]",
    );

    const $supervisorName = $form.find("[data-assignment-supervisor-name]");

    const $projectNotice = $form.find("[data-assignment-project-notice]");

    const $projectCompanyName = $form.find(
      "[data-assignment-project-company-name]",
    );

    if (!worksiteId) {
      hideAssignmentWorksiteDetails();

      return;
    }

    if (supervisorName) {
      $supervisorName.text(supervisorName);

      $supervisorNotice.removeClass("hidden");

      $supervisorMissing.addClass("hidden");
    } else {
      $supervisorName.text("—");

      $supervisorNotice.addClass("hidden");

      $supervisorMissing.removeClass("hidden");
    }

    if (isPartnerWorksite && projectCompanyName) {
      $projectCompanyName.text(projectCompanyName);

      $projectNotice.removeClass("hidden");
    } else {
      $projectCompanyName.text("");

      $projectNotice.addClass("hidden");
    }
  }

  /*
  |--------------------------------------------------------------------------
  | ASSIGNMENT MODAL — RESET
  |--------------------------------------------------------------------------
  */

  function resetAssignmentModal() {
    const $form = $("#aevon-assignment-form");

    if ($form[0]) {
      $form[0].reset();
    }

    $form.find('[name="assignment_id"]').val("");

    $form.find('[name="status"]').val("assigned");

    $form.find('[name="worker_id"]').val("").trigger("change");

    $form.find('[name="worksite_id"]').val("");

    $form.find('[name="accommodation_id"]').val("").trigger("change");

    $form.find('[name="room"]').val("");

    $form.find('[name="check_in"]').val("");

    $form.find('[name="check_out"]').val("");

    hideAssignmentWorksiteDetails();

    $("[data-assignment-modal-title]").text(t("js.assignment.new_title"));

    $("[data-assignment-modal-description]").text(
      t("js.assignment.new_description"),
    );

    $("#assignment-modal")
      .find('button[type="submit"]')
      .contents()
      .filter(function () {
        return this.nodeType === 3 && this.nodeValue.trim();
      })
      .last()
      .replaceWith(" " + t("js.assignment.save_assignment"));

    updateAssignmentModalState();
  }

  /*
  |--------------------------------------------------------------------------
  | ASSIGNMENT MODAL — STATUS CHANGE
  |--------------------------------------------------------------------------
  */

  $(document).on(
    "change",
    '#aevon-assignment-form [name="status"]',
    function () {
      updateAssignmentModalState();
    },
  );

  /*
  |--------------------------------------------------------------------------
  | ASSIGNMENT MODAL — WORKSITE CHANGE
  |--------------------------------------------------------------------------
  */

  $(document).on(
    "change",
    '#aevon-assignment-form [name="worksite_id"]',
    function () {
      updateAssignmentWorksiteState();
    },
  );

  /*
  |--------------------------------------------------------------------------
  | ASSIGNMENT MODAL — OPEN NEW
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-open-assignment-modal]", function () {
    const workerId = $(this).attr("data-prefill-worker-id");

    const worksiteId = $(this).attr("data-prefill-worksite-id");

    const $form = $("#aevon-assignment-form");

    resetAssignmentModal();

    if (workerId) {
      $form.find('[name="worker_id"]').val(String(workerId)).trigger("change");
    }

    if (worksiteId) {
      $form.find('[name="worksite_id"]').val(String(worksiteId));

      updateAssignmentWorksiteState();
    }

    updateAssignmentModalState({
      preserveValues: true,
    });

    openModal("#assignment-modal");
  });

  /*
  |--------------------------------------------------------------------------
  | ASSIGNMENT MODAL — LOAD EDIT DATA
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-edit-assignment]", function () {
    const assignmentId = $(this).data("assignment-id");

    if (!assignmentId) {
      return;
    }

    const $button = $(this);

    $button.prop("disabled", true).addClass("opacity-50");

    $.ajax({
      url: AevonWorkspace.ajaxUrl,

      method: "POST",

      data: {
        action: "aevon_workspace_get_assignment",

        nonce: AevonWorkspace.nonce,

        assignment_id: assignmentId,
      },

      success: function (response) {
        if (!response.success) {
          showToast(
            getResponseMessage(response, t("js.assignment.load_error")),
          );

          return;
        }

        const data = response.data;

        const $form = $("#aevon-assignment-form");

        resetAssignmentModal();

        $form.find('[name="assignment_id"]').val(data.id || "");

        $form
          .find('[name="worker_id"]')
          .val(data.worker_id || "")
          .trigger("change");

        $form.find('[name="status"]').val(data.status || "assigned");

        $form.find('[name="worksite_id"]').val(data.worksite_id || "");

        $form
          .find('[name="accommodation_id"]')
          .val(data.accommodation_id || "")
          .trigger("change");

        $form.find('[name="room"]').val(data.room || "");

        $form.find('[name="check_in"]').val(data.check_in || "");

        $form.find('[name="check_out"]').val(data.check_out || "");

        $form.find('[name="start_date"]').val(data.start_date || "");

        $form.find('[name="end_date"]').val(data.end_date || "");

        $form.find('[name="shift"]').val(data.shift || "");

        $form.find('[name="hours_per_day"]').val(data.hours_per_day || "");

        $form.find('[name="note"]').val(data.note || "");

        updateAssignmentModalState({
          preserveValues: true,
        });

        updateAssignmentWorksiteState();

        $("[data-assignment-modal-title]").text(t("js.assignment.edit_title"));

        $("[data-assignment-modal-description]").text(
          t("js.assignment.edit_description"),
        );

        $("#assignment-modal")
          .find('button[type="submit"]')
          .contents()
          .filter(function () {
            return this.nodeType === 3 && this.nodeValue.trim();
          })
          .last()
          .replaceWith(" " + t("js.common.save_changes"));

        openModal("#assignment-modal");
      },

      error: function (xhr) {
        showToast(getAjaxErrorMessage(xhr, t("js.assignment.load_error")));
      },

      complete: function () {
        $button.prop("disabled", false).removeClass("opacity-50");
      },
    });
  });

  /*
  |--------------------------------------------------------------------------
  | ASSIGNMENT MODAL — CLOSE
  |--------------------------------------------------------------------------
  */

  $(document).on(
    "click",
    "#close-assignment-modal, [data-close-assignment-modal]",
    function () {
      closeModal("#assignment-modal");
    },
  );

  /*
  |--------------------------------------------------------------------------
  | ASSIGNMENT FORM — SAVE
  |--------------------------------------------------------------------------
  */

  $("#aevon-assignment-form").on("submit", function (event) {
    event.preventDefault();

    const $form = $(this);

    const assignmentId = $form.find('[name="assignment_id"]').val();

    const action = assignmentId
      ? "aevon_workspace_update_assignment"
      : "aevon_workspace_create_assignment";

    ajaxSubmit($form, action, t("js.assignment.save_error"));
  });

  /*
  |--------------------------------------------------------------------------
  | WORKER WIZARD
  |--------------------------------------------------------------------------
  */

  const workerStepCount = $(".aevon-worker-step").length || 4;

  let workerStep = 1;

  function showWorkerStep(step) {
    const normalizedStep = Math.min(
      Math.max(parseInt(step, 10) || 1, 1),
      workerStepCount,
    );

    workerStep = normalizedStep;

    $(".aevon-worker-step").addClass("hidden");

    $('[data-worker-step="' + normalizedStep + '"]').removeClass("hidden");

    $(".aevon-worker-step-tab")
      .removeClass("bg-brand-primary text-white")
      .addClass("bg-slate-100 text-slate-600");

    $('[data-worker-step-tab="' + normalizedStep + '"]')
      .removeClass("bg-slate-100 text-slate-600")
      .addClass("bg-brand-primary text-white");

    $("#worker-step-prev").toggleClass("invisible", normalizedStep === 1);

    $("#worker-step-next").toggleClass(
      "hidden",
      normalizedStep === workerStepCount,
    );

    $("#worker-submit").toggleClass(
      "hidden",
      normalizedStep !== workerStepCount,
    );
  }

  $(document).on("click", "[data-worker-step-tab]", function () {
    showWorkerStep($(this).data("worker-step-tab"));
  });

  $("#worker-step-next").on("click", function () {
    if (workerStep < workerStepCount) {
      showWorkerStep(workerStep + 1);
    }
  });

  $("#worker-step-prev").on("click", function () {
    if (workerStep > 1) {
      showWorkerStep(workerStep - 1);
    }
  });

  /*
  |--------------------------------------------------------------------------
  | WORKER PORTAL ACCOUNT
  |--------------------------------------------------------------------------
  */

  function generateWorkerPassword(length = 16) {
    const lowercase = "abcdefghijkmnopqrstuvwxyz";

    const uppercase = "ABCDEFGHJKLMNPQRSTUVWXYZ";

    const numbers = "23456789";

    const symbols = "!@#$%&*+-=?";

    const allCharacters = lowercase + uppercase + numbers + symbols;

    const requiredCharacters = [lowercase, uppercase, numbers, symbols].map(
      function (characterSet) {
        const values = new Uint32Array(1);

        window.crypto.getRandomValues(values);

        return characterSet[values[0] % characterSet.length];
      },
    );

    const remainingCharacters = [];

    for (let index = requiredCharacters.length; index < length; index++) {
      const values = new Uint32Array(1);

      window.crypto.getRandomValues(values);

      remainingCharacters.push(allCharacters[values[0] % allCharacters.length]);
    }

    const password = requiredCharacters.concat(remainingCharacters);

    for (let index = password.length - 1; index > 0; index--) {
      const values = new Uint32Array(1);

      window.crypto.getRandomValues(values);

      const randomIndex = values[0] % (index + 1);

      const temporaryValue = password[index];

      password[index] = password[randomIndex];

      password[randomIndex] = temporaryValue;
    }

    return password.join("");
  }

  function normalizeWorkerUsername(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9._-]/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  }

  function toggleWorkerAccountFields() {
    const $form = $("#aevon-worker-form");

    const createAccount = $form
      .find('[name="create_user_account"]')
      .is(":checked");

    $("[data-worker-account-fields]").toggleClass("hidden", !createAccount);

    $form
      .find('[name="login_username"]')
      .prop("required", createAccount)
      .prop("disabled", !createAccount);

    $form
      .find('[name="login_password"]')
      .prop("required", createAccount)
      .prop("disabled", !createAccount);

    $("[data-generate-worker-password]").prop("disabled", !createAccount);

    $("[data-copy-worker-credentials]").prop("disabled", !createAccount);
  }

  $(document).on("change", "[data-create-worker-account]", function () {
    toggleWorkerAccountFields();
  });

  $(document).on("click", "[data-generate-worker-password]", function () {
    const password = generateWorkerPassword();

    $("#aevon-worker-form")
      .find('[name="login_password"]')
      .val(password)
      .trigger("focus");
  });

  $(document).on("click", "[data-copy-worker-credentials]", async function () {
    const $form = $("#aevon-worker-form");

    const username = String(
      $form.find('[name="login_username"]').val() || "",
    ).trim();

    const password = String($form.find('[name="login_password"]').val() || "");

    if (!username || !password) {
      showToast(t("js.worker.credentials_required"));

      return;
    }

    const credentials = [
      t("js.worker.portal_title"),
      t("js.worker.username_value", {
        username: username,
      }),
      t("js.worker.password_value", {
        password: password,
      }),
    ].join("\n");

    let copied = false;

    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(credentials);

        copied = true;
      } catch (error) {
        copied = false;
      }
    }

    if (!copied) {
      const textarea = document.createElement("textarea");

      textarea.value = credentials;

      textarea.setAttribute("readonly", "");

      textarea.style.position = "fixed";
      textarea.style.top = "-9999px";
      textarea.style.left = "-9999px";

      document.body.appendChild(textarea);

      textarea.focus();
      textarea.select();

      try {
        copied = document.execCommand("copy");
      } catch (error) {
        copied = false;
      }

      document.body.removeChild(textarea);
    }

    if (copied) {
      showToast(t("js.worker.credentials_copied"), "success");
    } else {
      showToast(t("js.worker.credentials_copy_error"), "error");
    }
  });

  /*
  |--------------------------------------------------------------------------
  | AUTO-GENERATE WORKER USERNAME
  |--------------------------------------------------------------------------
  */

  $(document).on(
    "input",
    '#aevon-worker-form [name="employee_id"]',
    function () {
      const $form = $("#aevon-worker-form");

      const workerId = $form.find('[name="worker_id"]').val();

      const $usernameField = $form.find('[name="login_username"]');

      const usernameWasEdited =
        $usernameField.attr("data-manually-edited") === "1";

      if (workerId || usernameWasEdited) {
        return;
      }

      $usernameField.val(normalizeWorkerUsername($(this).val()));
    },
  );

  $(document).on(
    "input",
    '#aevon-worker-form [name="login_username"]',
    function () {
      $(this).attr("data-manually-edited", "1");
    },
  );

  /*
  |--------------------------------------------------------------------------
  | WORKER SUPERVISOR STATE
  |--------------------------------------------------------------------------
  */

  function setWorkerSupervisorState(enabled, options = {}) {
    const $form = $("#aevon-worker-form");

    const $checkbox = $form.find("#aevon-worker-is-supervisor");

    const $track = $form.find("[data-worker-supervisor-track]");

    const $thumb = $form.find("[data-worker-supervisor-thumb]");

    const $requirement = $form.find("[data-supervisor-account-requirement]");

    const hasUserAccount =
      options.hasUserAccount === true ||
      $form.attr("data-has-user-account") === "1";

    const isEnabled = enabled === true;

    $checkbox.prop("checked", isEnabled);

    $track.css("background-color", isEnabled ? "#2563eb" : "#cbd5e1");

    $thumb.css(
      "transform",
      isEnabled ? "translateX(1.25rem)" : "translateX(0)",
    );

    $requirement.toggleClass("hidden", !isEnabled || hasUserAccount);

    if (isEnabled && !hasUserAccount) {
      $form.find('[name="create_user_account"]').prop("checked", true);

      toggleWorkerAccountFields();
    }
  }

  $(document).on("change", "#aevon-worker-is-supervisor", function () {
    setWorkerSupervisorState($(this).is(":checked"));
  });

  /*
  |--------------------------------------------------------------------------
  | WORKER DOCUMENTS
  |--------------------------------------------------------------------------
  */

  let workerDocumentIndex = 0;

  function escapeWorkerDocumentHtml(value) {
    return escapeHtml(value);
  }

  function updateWorkerDocumentsEmptyState() {
    const hasDocuments =
      $("[data-worker-documents] [data-worker-document-row]").length > 0;

    $("[data-worker-documents-empty]").toggleClass("hidden", hasDocuments);
  }

  function createWorkerDocumentRow(document = {}) {
    const index = workerDocumentIndex++;

    const name = escapeWorkerDocumentHtml(document.name || "");

    const expiryDate = escapeWorkerDocumentHtml(document.expiry_date || "");

    const attachmentId = Number(document.attachment_id || 0);

    const filename = escapeWorkerDocumentHtml(document.filename || "");

    const url = document.url ? String(document.url) : "";

    const safeUrl = escapeWorkerDocumentHtml(url);

    const existingFileHtml = attachmentId
      ? `
        <div
          data-worker-document-existing-file
          class="mt-3 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3">

          <div class="min-w-0">

            <div class="text-xs font-semibold uppercase tracking-wide text-emerald-700">
              ${t("js.worker_documents.current_file")}
            </div>

            <div class="mt-1 truncate text-sm font-medium text-emerald-950">
              ${filename || t("js.worker_documents.document")}
            </div>

          </div>

          ${
            safeUrl
              ? `
                <a
                  href="${safeUrl}"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="inline-flex shrink-0 items-center gap-2 text-sm font-semibold text-emerald-700 hover:underline">

                  <i
                    data-feather="external-link"
                    class="h-4 w-4">
                  </i>

                  ${t("js.common.open")}

                </a>
              `
              : ""
          }

        </div>
      `
      : "";

    const $row = $(`
      <div
        data-worker-document-row
        class="rounded-2xl border border-slate-200 bg-slate-50 p-5">

        <input
          type="hidden"
          name="worker_document_attachment_ids[${index}]"
          value="${attachmentId || ""}">

        <div class="grid gap-4 md:grid-cols-12">

          <div class="md:col-span-5">

            <label
              class="mb-2 block text-sm font-medium text-slate-700">

              ${t("js.worker_documents.name")}
            </label>

            <input
              type="text"
              name="worker_document_names[${index}]"
              value="${name}"
              placeholder="${t("js.worker_documents.name_placeholder")}"
              class="w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-slate-900 outline-none transition focus:border-brand-primary focus:ring-2 focus:ring-brand-primary/10">

          </div>

          <div class="md:col-span-3">

            <label
              class="mb-2 block text-sm font-medium text-slate-700">

              ${t("js.worker_documents.expiry_date")}
            </label>

            <input
              type="date"
              name="worker_document_expiry_dates[${index}]"
              value="${expiryDate}"
              class="w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-slate-900 outline-none transition focus:border-brand-primary focus:ring-2 focus:ring-brand-primary/10">

          </div>

          <div class="md:col-span-4">

            <label
              class="mb-2 block text-sm font-medium text-slate-700">

              ${
                attachmentId
                  ? t("js.worker_documents.replace_file")
                  : t("js.worker_documents.file")
              }
            </label>

            <input
              type="file"
              name="worker_documents[${index}]"
              accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp"
              class="block w-full cursor-pointer rounded-xl border border-slate-300 bg-white text-sm text-slate-600 file:mr-4 file:border-0 file:border-r file:border-slate-200 file:bg-slate-50 file:px-4 file:py-3 file:text-sm file:font-semibold file:text-slate-700 hover:file:bg-slate-100">

          </div>

        </div>

        ${existingFileHtml}

        <div class="mt-4 flex justify-end">

          <button
            type="button"
            data-remove-worker-document
            class="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold text-red-600 transition hover:bg-red-50">

            <i
              data-feather="trash-2"
              class="h-4 w-4">
            </i>

            ${t("js.worker_documents.remove")}

          </button>

        </div>

      </div>
    `);

    return $row;
  }

  function addWorkerDocumentRow(document = {}) {
    const $container = $("[data-worker-documents]");

    if (!$container.length) {
      return;
    }

    $container.append(createWorkerDocumentRow(document));

    updateWorkerDocumentsEmptyState();

    if (window.feather && typeof window.feather.replace === "function") {
      window.feather.replace();
    }
  }

  function resetWorkerDocuments() {
    workerDocumentIndex = 0;

    $("[data-worker-documents]").empty();

    updateWorkerDocumentsEmptyState();
  }

  function loadWorkerDocuments(documents) {
    resetWorkerDocuments();

    if (!Array.isArray(documents)) {
      return;
    }

    documents.forEach(function (document) {
      addWorkerDocumentRow(document);
    });
  }

  $(document).on("click", "[data-add-worker-document]", function () {
    addWorkerDocumentRow();
  });

  $(document).on("click", "[data-remove-worker-document]", function () {
    $(this).closest("[data-worker-document-row]").remove();

    updateWorkerDocumentsEmptyState();
  });

  /*
  |--------------------------------------------------------------------------
  | WORKER DOCUMENT VALIDATION
  |--------------------------------------------------------------------------
  */

  function validateWorkerDocuments() {
    let isValid = true;

    let errorMessage = "";

    $("[data-worker-documents] [data-worker-document-row]").each(function () {
      const $row = $(this);

      const name = String(
        $row.find('[name^="worker_document_names"]').val() || "",
      ).trim();

      const attachmentId = Number(
        $row.find('[name^="worker_document_attachment_ids"]').val() || 0,
      );

      const fileInput = $row.find('input[type="file"]')[0];

      const hasNewFile =
        fileInput && fileInput.files && fileInput.files.length > 0;

      if (!name && (attachmentId || hasNewFile)) {
        isValid = false;

        errorMessage = t("js.worker_documents.name_required");

        return false;
      }

      if (name && !attachmentId && !hasNewFile) {
        isValid = false;

        errorMessage = t("js.worker_documents.file_required");

        return false;
      }

      if (hasNewFile) {
        const file = fileInput.files[0];

        const extension = String(
          file.name.split(".").pop() || "",
        ).toLowerCase();

        const allowedExtensions = ["pdf", "jpg", "jpeg", "png", "webp"];

        if (!allowedExtensions.includes(extension)) {
          isValid = false;

          errorMessage = t("js.worker_documents.invalid_type");

          return false;
        }
      }
    });

    return {
      valid: isValid,
      message: errorMessage,
    };
  }

  /*
  |--------------------------------------------------------------------------
  | WORKER MODAL — RESET
  |--------------------------------------------------------------------------
  */

  function resetWorkerModal() {
    const $form = $("#aevon-worker-form");

    if ($form[0]) {
      $form[0].reset();
    }

    $form.removeAttr("data-has-user-account");

    $form.find('[name="worker_id"]').val("");

    resetWorkerDocuments();

    $form.find('[name="create_user_account"]').prop("checked", true);

    $form
      .find('[name="login_username"]')
      .val("")
      .removeAttr("data-manually-edited");

    $form.find('[name="login_password"]').val(generateWorkerPassword());

    $form.find("[data-worker-account-section]").removeClass("hidden");

    $form.find("[data-worker-existing-account]").addClass("hidden");

    setWorkerSupervisorState(false, {
      hasUserAccount: false,
    });

    $("[data-worker-modal-title]").text(t("js.worker.add_title"));

    $("[data-worker-modal-description]").text(t("js.worker.add_description"));

    $("#worker-submit").text(t("js.worker.save_worker"));

    toggleWorkerAccountFields();

    showWorkerStep(1);
  }

  /*
  |--------------------------------------------------------------------------
  | WORKER MODAL — OPEN NEW
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-open-worker-modal]", function () {
    resetWorkerModal();

    openModal("#worker-modal");
  });

  /*
  |--------------------------------------------------------------------------
  | WORKER MODAL — LOAD EDIT DATA
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-edit-worker]", function () {
    const workerId = Number($(this).attr("data-worker-id") || 0);

    const requestedStep = parseInt($(this).attr("data-worker-step"), 10) || 1;

    if (!workerId) {
      return;
    }

    const $button = $(this);

    $button.prop("disabled", true).addClass("opacity-50");

    $.ajax({
      url: AevonWorkspace.ajaxUrl,
      method: "POST",

      data: {
        action: "aevon_workspace_get_worker",

        nonce: AevonWorkspace.nonce,

        worker_id: workerId,
      },

      success: function (response) {
        if (!response || !response.success || !response.data) {
          showToast(getResponseMessage(response, t("js.worker.load_error")));

          return;
        }

        const data = response.data;

        const $modal = $("#worker-modal");

        const $form = $modal.find("#aevon-worker-form");

        if (!$form.length) {
          showToast(t("js.worker.form_not_found"));

          return;
        }

        const isSupervisor = isCheckedValue(data.is_supervisor);

        const hasUserAccount = isCheckedValue(data.has_user_account);

        resetWorkerModal();

        $form.attr("data-has-user-account", hasUserAccount ? "1" : "0");

        $form.find('[name="worker_id"]').val(data.id || "");

        $form.find('[name="worker_name"]').val(data.worker_name || "");

        $form.find('[name="employee_id"]').val(data.employee_id || "");

        $form.find('[name="company"]').val(data.company || "");

        $form.find('[name="department"]').val(data.department || "");

        $form.find('[name="position"]').val(data.position || "");

        $form.find('[name="phone"]').val(data.phone || "");

        $form.find('[name="email"]').val(data.email || "");

        $form
          .find('[name="emergency_contact"]')
          .val(data.emergency_contact || "");

        $form.find('[name="hire_date"]').val(data.hire_date || "");

        $form.find('[name="contract_type"]').val(data.contract_type || "");

        $form.find('[name="id_card"]').val(data.id_card || "");

        $form.find('[name="passport"]').val(data.passport || "");

        $form.find('[name="work_permit"]').val(data.work_permit || "");

        $form
          .find('[name="work_permit_expiry"]')
          .val(data.work_permit_expiry || "");

        $form.find('[name="city"]').val(data.city || "");

        $form.find('[name="company_car"]').val(data.company_car || "");

        $form.find('[name="fuel_card"]').val(data.fuel_card || "");

        $form.find('[name="tools"]').val(data.tools || "");

        $form.find('[name="card"]').val(data.card || "");

        $form.find('[name="notes"]').val(data.notes || "");

        loadWorkerDocuments(data.documents || []);

        $form
          .find('[name="active"]')
          .prop("checked", isCheckedValue(data.active));

        $form
          .find('[name="first_aid"]')
          .prop("checked", isCheckedValue(data.first_aid));

        $form
          .find('[name="forklift"]')
          .prop("checked", isCheckedValue(data.forklift));

        $form
          .find('[name="electrical_license"]')
          .prop("checked", isCheckedValue(data.electrical_license));

        $form
          .find('[name="safety_training"]')
          .prop("checked", isCheckedValue(data.safety_training));

        if (hasUserAccount) {
          $form.find("[data-worker-account-section]").addClass("hidden");

          $form.find("[data-worker-existing-account]").removeClass("hidden");

          $form.find('[name="create_user_account"]').prop("checked", false);

          $form.find('[name="login_username"]').val(data.username || "");

          $form.find('[name="login_password"]').val("");
        } else {
          $form.find("[data-worker-account-section]").removeClass("hidden");

          $form.find("[data-worker-existing-account]").addClass("hidden");

          $form
            .find('[name="create_user_account"]')
            .prop("checked", isSupervisor);

          $form
            .find('[name="login_username"]')
            .val("")
            .removeAttr("data-manually-edited");

          $form.find('[name="login_password"]').val(generateWorkerPassword());
        }

        setWorkerSupervisorState(isSupervisor, {
          hasUserAccount: hasUserAccount,
        });

        toggleWorkerAccountFields();

        $modal
          .find("[data-worker-modal-title]")
          .text(t("js.worker.edit_title"));

        $modal
          .find("[data-worker-modal-description]")
          .text(t("js.worker.edit_description"));

        $modal.find("#worker-submit").text(t("js.common.save_changes"));

        showWorkerStep(requestedStep);

        openModal("#worker-modal");
      },

      error: function (xhr) {
        showToast(getAjaxErrorMessage(xhr, t("js.worker.load_error")));
      },

      complete: function () {
        $button.prop("disabled", false).removeClass("opacity-50");
      },
    });
  });

  /*
  |--------------------------------------------------------------------------
  | WORKER MODAL — CLOSE
  |--------------------------------------------------------------------------
  */

  $("#close-worker-modal").on("click", function () {
    closeModal("#worker-modal");
  });

  /*
  |--------------------------------------------------------------------------
  | WORKER FORM — SAVE WITH DOCUMENT UPLOADS
  |--------------------------------------------------------------------------
  */

  $("#aevon-worker-form").on("submit", function (event) {
    event.preventDefault();

    const $form = $(this);

    const workerId = $form.find('[name="worker_id"]').val();

    const createAccount = $form
      .find('[name="create_user_account"]')
      .is(":checked");

    if (!workerId && createAccount) {
      const username = String(
        $form.find('[name="login_username"]').val() || "",
      ).trim();

      const password = String(
        $form.find('[name="login_password"]').val() || "",
      );

      if (!username) {
        showToast(t("js.worker.username_required"));

        showWorkerStep(2);

        $form.find('[name="login_username"]').trigger("focus");

        return;
      }

      if (password.length < 10) {
        showToast(t("js.worker.temporary_password_length"));

        showWorkerStep(2);

        $form.find('[name="login_password"]').trigger("focus");

        return;
      }
    }

    const action = workerId
      ? "aevon_workspace_update_worker"
      : "aevon_workspace_create_worker";

    const formData = new FormData(this);

    formData.append("action", action);
    formData.append("nonce", AevonWorkspace.nonce);

    const $button = $form.find('button[type="submit"]');

    const originalButtonHtml = $button.html();

    $button.prop("disabled", true).addClass("cursor-not-allowed opacity-60")
      .html(`
        <span class="inline-flex items-center justify-center gap-2">
          <svg
            class="h-4 w-4 animate-spin"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true">

            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4">
            </circle>

            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z">
            </path>
          </svg>

          ${t("js.common.saving")}
        </span>
      `);

    $.ajax({
      url: AevonWorkspace.ajaxUrl,

      method: "POST",

      data: formData,

      processData: false,
      contentType: false,

      success: function (response) {
        if (!response || !response.success) {
          showToast(getResponseMessage(response, t("js.worker.save_error")));

          return;
        }

        showToast(
          getResponseMessage(
            response,
            workerId ? t("js.worker.updated") : t("js.worker.created"),
          ),
          "success",
        );

        setTimeout(function () {
          window.location.reload();
        }, 600);
      },

      error: function (xhr) {
        showToast(getAjaxErrorMessage(xhr, t("js.worker.save_retry_error")));
      },

      complete: function () {
        $button
          .prop("disabled", false)
          .removeClass("cursor-not-allowed opacity-60")
          .html(originalButtonHtml);
      },
    });
  });

  /*
  |--------------------------------------------------------------------------
  | WORKER PASSWORD
  |--------------------------------------------------------------------------
  */

  function generateStrongWorkerPassword(length = 16) {
    const lowercase = "abcdefghijkmnopqrstuvwxyz";

    const uppercase = "ABCDEFGHJKLMNPQRSTUVWXYZ";

    const numbers = "23456789";

    const symbols = "!@#$%&*+-=?";

    const allCharacters = lowercase + uppercase + numbers + symbols;

    const password = [
      getSecureRandomCharacter(lowercase),
      getSecureRandomCharacter(uppercase),
      getSecureRandomCharacter(numbers),
      getSecureRandomCharacter(symbols),
    ];

    while (password.length < length) {
      password.push(getSecureRandomCharacter(allCharacters));
    }

    for (let index = password.length - 1; index > 0; index--) {
      const randomIndex = getSecureRandomNumber(index + 1);

      const temporaryValue = password[index];

      password[index] = password[randomIndex];

      password[randomIndex] = temporaryValue;
    }

    return password.join("");
  }

  function getSecureRandomNumber(maximum) {
    if (window.crypto && window.crypto.getRandomValues) {
      const values = new Uint32Array(1);

      window.crypto.getRandomValues(values);

      return values[0] % maximum;
    }

    return Math.floor(Math.random() * maximum);
  }

  function getSecureRandomCharacter(characters) {
    return characters[getSecureRandomNumber(characters.length)];
  }

  function getWorkerPasswordRules(password, confirmation) {
    return {
      length: password.length >= 12,
      lowercase: /[a-z]/.test(password),
      uppercase: /[A-Z]/.test(password),
      number: /[0-9]/.test(password),
      symbol: /[^a-zA-Z0-9]/.test(password),
      match: Boolean(password) && password === confirmation,
    };
  }

  function updateWorkerPasswordStrength() {
    const $form = $("#aevon-worker-password-form");

    if (!$form.length) {
      return;
    }

    const password = String($form.find('[name="new_password"]').val() || "");

    const confirmation = String(
      $form.find('[name="confirm_password"]').val() || "",
    );

    const rules = getWorkerPasswordRules(password, confirmation);

    Object.keys(rules).forEach(function (rule) {
      const $rule = $form.find('[data-password-rule="' + rule + '"]');

      const text = $rule.text().replace(/^[○✓]\s*/, "");

      if (rules[rule]) {
        $rule
          .text("✓ " + text)
          .removeClass("text-slate-500 text-red-600")
          .addClass("font-medium text-emerald-700");
      } else {
        $rule
          .text("○ " + text)
          .removeClass("font-medium text-emerald-700")
          .addClass("text-slate-500");
      }
    });

    return Object.values(rules).every(Boolean);
  }

  $(document).on(
    "input",
    [
      '#aevon-worker-password-form [name="new_password"]',
      '#aevon-worker-password-form [name="confirm_password"]',
    ].join(","),
    function () {
      updateWorkerPasswordStrength();
    },
  );

  $(document).on("click", "[data-generate-worker-new-password]", function () {
    const $form = $("#aevon-worker-password-form");

    const password = generateStrongWorkerPassword();

    $form.find('[name="new_password"]').val(password);

    $form.find('[name="confirm_password"]').val(password);

    updateWorkerPasswordStrength();

    showToast(t("js.password.generated"), "success");
  });

  $(document).on("click", "[data-toggle-password]", function () {
    const inputId = $(this).attr("data-toggle-password");

    const $input = $("#" + inputId);

    if (!$input.length) {
      return;
    }

    const showPassword = $input.attr("type") === "password";

    $input.attr("type", showPassword ? "text" : "password");

    $(this).attr(
      "aria-label",
      showPassword ? t("js.password.hide") : t("js.password.show"),
    );

    const icon = this.querySelector("[data-feather]");

    if (icon) {
      icon.setAttribute("data-feather", showPassword ? "eye-off" : "eye");

      if (window.feather) {
        window.feather.replace();
      }
    }
  });

  $("#aevon-worker-password-form").on("submit", function (event) {
    event.preventDefault();

    const $form = $(this);

    const $button = $form.find('button[type="submit"]');

    const currentPassword = String(
      $form.find('[name="current_password"]').val() || "",
    );

    const newPassword = String($form.find('[name="new_password"]').val() || "");

    const confirmPassword = String(
      $form.find('[name="confirm_password"]').val() || "",
    );

    if (!currentPassword || !newPassword || !confirmPassword) {
      showToast(t("js.password.all_fields_required"), "error");

      return;
    }

    if (!updateWorkerPasswordStrength()) {
      showToast(t("js.password.requirements_error"), "error");

      return;
    }

    $button.prop("disabled", true).addClass("opacity-50");

    $.ajax({
      url: AevonWorkspace.ajaxUrl,
      method: "POST",

      data: {
        action: "aevon_workspace_worker_change_password",

        nonce: AevonWorkspace.nonce,

        current_password: currentPassword,

        new_password: newPassword,

        confirm_password: confirmPassword,
      },

      success: function (response) {
        if (!response.success) {
          showToast(
            getResponseMessage(response, t("js.password.change_error")),
            "error",
          );

          return;
        }

        if ($form[0]) {
          $form[0].reset();
        }

        updateWorkerPasswordStrength();

        showToast(
          getResponseMessage(response, t("js.password.changed")),
          "success",
        );

        setTimeout(function () {
          window.location.reload();
        }, 700);
      },

      error: function (xhr) {
        showToast(
          getAjaxErrorMessage(xhr, t("js.password.change_error")),
          "error",
        );
      },

      complete: function () {
        $button.prop("disabled", false).removeClass("opacity-50");
      },
    });
  });

  /*
  |--------------------------------------------------------------------------
  | WORKSITE WIZARD
  |--------------------------------------------------------------------------
  |
  | Worksite has 5 steps:
  | 1. General
  | 2. Location
  | 3. Contact
  | 4. Planning
  | 5. Partners
  |
  */

  const worksiteStepCount = 5;

  let worksiteStep = 1;

  function showWorksiteStep(step) {
    const normalizedStep = Math.min(
      Math.max(parseInt(step, 10) || 1, 1),
      worksiteStepCount,
    );

    worksiteStep = normalizedStep;

    $(".aevon-worksite-step").addClass("hidden");

    $('[data-worksite-step="' + normalizedStep + '"]').removeClass("hidden");

    $(".aevon-worksite-step-tab")
      .removeClass("bg-brand-primary text-white")
      .addClass("bg-slate-100 text-slate-600");

    $('[data-worksite-step-tab="' + normalizedStep + '"]')
      .removeClass("bg-slate-100 text-slate-600")
      .addClass("bg-brand-primary text-white");

    $("#worksite-step-prev").toggleClass("invisible", normalizedStep === 1);

    $("#worksite-step-next").toggleClass(
      "hidden",
      normalizedStep === worksiteStepCount,
    );

    $("#worksite-submit").toggleClass(
      "hidden",
      normalizedStep !== worksiteStepCount,
    );
  }

  $(document).on("click", "[data-worksite-step-tab]", function () {
    showWorksiteStep($(this).data("worksite-step-tab"));
  });

  $("#worksite-step-next").on("click", function () {
    if (worksiteStep < worksiteStepCount) {
      showWorksiteStep(worksiteStep + 1);
    }
  });

  $("#worksite-step-prev").on("click", function () {
    if (worksiteStep > 1) {
      showWorksiteStep(worksiteStep - 1);
    }
  });

  /*
  |--------------------------------------------------------------------------
  | WORKSITE MODAL — RESET
  |--------------------------------------------------------------------------
  */

  function resetWorksiteModal() {
    const $form = $("#aevon-worksite-form");

    if ($form[0]) {
      $form[0].reset();
    }

    $form.find('[name="worksite_id"]').val("");

    $form.find('[name="status"]').val("upcoming");

    /*
     * Reset all selected partner companies in the multiple select.
     */
    $form.find('[name="partner_companies[]"]').val([]).trigger("change");

    $("#worksite-modal h2").text(t("js.worksite.add_title"));

    $("#worksite-submit").text(t("js.worksite.save_worksite"));

    showWorksiteStep(1);
  }

  /*
  |--------------------------------------------------------------------------
  | WORKSITE MODAL — OPEN NEW
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-open-worksite-modal]", function () {
    resetWorksiteModal();

    openModal("#worksite-modal");
  });

  /*
  |--------------------------------------------------------------------------
  | WORKSITE MODAL — LOAD EDIT DATA
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-edit-worksite]", function () {
    const worksiteId = $(this).data("worksite-id");

    if (!worksiteId) {
      return;
    }

    const $button = $(this);

    $button.prop("disabled", true).addClass("opacity-50");

    $.ajax({
      url: AevonWorkspace.ajaxUrl,
      method: "POST",

      data: {
        action: "aevon_workspace_get_worksite",
        nonce: AevonWorkspace.nonce,
        worksite_id: worksiteId,
      },

      success: function (response) {
        if (!response.success) {
          showToast(getResponseMessage(response, t("js.worksite.load_error")));

          return;
        }

        const data = response.data;

        const $form = $("#aevon-worksite-form");

        resetWorksiteModal();

        $form.find('[name="worksite_id"]').val(data.id || "");

        $form.find('[name="worksite_name"]').val(data.title || "");

        $form.find('[name="client"]').val(data.client || "");

        $form.find('[name="company"]').val(data.company || "");

        $form.find('[name="project_manager"]').val(data.project_manager || "");

        $form.find('[name="status"]').val(data.status || "active");

        $form.find('[name="address"]').val(data.address || "");

        $form.find('[name="country"]').val(data.country || "");

        $form.find('[name="city"]').val(data.city || "");

        $form.find('[name="maps_url"]').val(data.maps_url || "");

        $form.find('[name="supervisor_id"]').val(data.supervisor_id || "");

        $form.find('[name="contact_phone"]').val(data.contact_phone || "");

        $form.find('[name="contact_email"]').val(data.contact_email || "");

        $form.find('[name="start_date"]').val(data.start_date || "");

        $form.find('[name="end_date"]').val(data.end_date || "");

        $form.find('[name="capacity"]').val(data.capacity || "");

        $form
          .find('[name="required_certificates"]')
          .val(data.required_certificates || "");

        $form.find('[name="notes"]').val(data.notes || "");

        /*
         * Partner company IDs are returned as an array.
         * String conversion ensures they match option values.
         */
        const partnerCompanies = Array.isArray(data.partner_companies)
          ? data.partner_companies.map(String)
          : [];

        $form
          .find('[name="partner_companies[]"]')
          .val(partnerCompanies)
          .trigger("change");

        $("#worksite-modal h2").text(t("js.worksite.edit_title"));

        $("#worksite-submit").text(t("js.common.save_changes"));

        showWorksiteStep(1);

        openModal("#worksite-modal");
      },

      error: function (xhr) {
        showToast(getAjaxErrorMessage(xhr, t("js.worksite.load_error")));
      },

      complete: function () {
        $button.prop("disabled", false).removeClass("opacity-50");
      },
    });
  });

  /*
  |--------------------------------------------------------------------------
  | WORKSITE MODAL — CLOSE
  |--------------------------------------------------------------------------
  */

  $("#close-worksite-modal").on("click", function () {
    closeModal("#worksite-modal");
  });

  /*
  |--------------------------------------------------------------------------
  | WORKSITE FORM — SAVE
  |--------------------------------------------------------------------------
  */

  $("#aevon-worksite-form").on("submit", function (event) {
    event.preventDefault();

    const $form = $(this);

    const worksiteId = $form.find('[name="worksite_id"]').val();

    const action = worksiteId
      ? "aevon_workspace_update_worksite"
      : "aevon_workspace_create_worksite";

    ajaxSubmit($form, action, t("js.worksite.save_error"));
  });

  /*
  |--------------------------------------------------------------------------
  | DELETE ASSIGNMENT
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-aevon-delete-assignment]", function () {
    const $button = $(this);

    const assignmentId = $button.data("assignment-id");

    if (!assignmentId) {
      return;
    }

    showConfirm(
      t("js.delete_assignment.title"),
      t("js.delete_assignment.message"),
      function () {
        $button.prop("disabled", true).addClass("opacity-50");

        $.ajax({
          url: AevonWorkspace.ajaxUrl,
          method: "POST",

          data: {
            action: "aevon_workspace_delete_assignment",
            nonce: AevonWorkspace.nonce,
            assignment_id: assignmentId,
          },

          success: function (response) {
            if (!response.success) {
              showToast(
                getResponseMessage(response, t("js.delete_assignment.error")),
              );

              return;
            }

            window.location.reload();
          },

          error: function (xhr) {
            showToast(
              getAjaxErrorMessage(xhr, t("js.delete_assignment.error")),
            );
          },

          complete: function () {
            $button.prop("disabled", false).removeClass("opacity-50");
          },
        });
      },
    );
  });

  /*
  |--------------------------------------------------------------------------
  | DELETE WORKER
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-aevon-delete-worker]", function () {
    const $button = $(this);

    const workerId = $button.data("worker-id");

    const workerName = $button.closest("tr").find("td:first").text().trim();

    if (!workerId) {
      return;
    }

    showConfirm(
      t("js.delete_worker.title"),
      t("js.delete_worker.message", {
        name: escapeHtml(workerName),
      }),
      function () {
        $button.prop("disabled", true).addClass("opacity-50");

        $.ajax({
          url: AevonWorkspace.ajaxUrl,
          method: "POST",

          data: {
            action: "aevon_workspace_delete_worker",
            nonce: AevonWorkspace.nonce,
            worker_id: workerId,
          },

          success: function (response) {
            if (!response.success) {
              showToast(
                getResponseMessage(response, t("js.delete_worker.error")),
              );

              return;
            }

            window.location.reload();
          },

          error: function (xhr) {
            showToast(getAjaxErrorMessage(xhr, t("js.delete_worker.error")));
          },

          complete: function () {
            $button.prop("disabled", false).removeClass("opacity-50");
          },
        });
      },
    );
  });

  /*
  |--------------------------------------------------------------------------
  | DELETE WORKSITE
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-aevon-delete-worksite]", function () {
    const $button = $(this);

    const worksiteId = $button.data("worksite-id");

    const worksiteName = $button.closest("tr").find("td:first").text().trim();

    if (!worksiteId) {
      return;
    }

    showConfirm(
      t("js.delete_worksite.title"),
      t("js.delete_worksite.message", {
        name: escapeHtml(worksiteName),
      }),
      function () {
        $button.prop("disabled", true).addClass("opacity-50");

        $.ajax({
          url: AevonWorkspace.ajaxUrl,
          method: "POST",

          data: {
            action: "aevon_workspace_delete_worksite",
            nonce: AevonWorkspace.nonce,
            worksite_id: worksiteId,
          },

          success: function (response) {
            if (!response.success) {
              showToast(
                getResponseMessage(response, t("js.delete_worksite.error")),
              );

              return;
            }

            window.location.reload();
          },

          error: function (xhr) {
            showToast(getAjaxErrorMessage(xhr, t("js.delete_worksite.error")));
          },

          complete: function () {
            $button.prop("disabled", false).removeClass("opacity-50");
          },
        });
      },
    );
  });

  /*
  |--------------------------------------------------------------------------
  | WORKSITE SUPERVISORS MODAL
  |--------------------------------------------------------------------------
  */

  function resetWorksiteSupervisorsModal() {
    const $modal = $("#worksite-supervisors-modal");

    const $form = $("#aevon-worksite-supervisors-form");

    if ($form[0]) {
      $form[0].reset();
    }

    $form.find('[name="worksite_id"]').val("");

    $modal
      .find("[data-worksite-supervisors-modal-title]")
      .text(t("js.supervisors.title"));

    $modal
      .find("[data-worksite-supervisors-modal-description]")
      .text(t("js.supervisors.description"));

    $modal.find("[data-worksite-supervisors-worksite-name]").text("—");

    $modal.find("[data-worksite-supervisors-company-name]").text("—");

    $modal
      .find("[data-worksite-supervisors-company-type]")
      .text(t("js.supervisors.company"));

    $modal.find("[data-worksite-supervisors-options]").empty();

    $modal.find("[data-worksite-supervisors-other-groups]").empty();

    $modal.find("[data-worksite-supervisors-loading]").removeClass("hidden");

    $modal.find("[data-worksite-supervisors-error]").addClass("hidden");

    $modal.find("[data-worksite-supervisors-content]").addClass("hidden");

    $modal.find("[data-worksite-supervisors-empty]").addClass("hidden");

    $modal
      .find("[data-worksite-supervisors-other-groups-section]")
      .addClass("hidden");

    $modal
      .find("[data-save-worksite-supervisors]")
      .prop("disabled", true)
      .removeClass("opacity-50");

    $modal
      .find("[data-worksite-supervisors-submit-label]")
      .text(t("js.supervisors.save"));
  }

  function escapeWorksiteSupervisorHtml(value) {
    return escapeHtml(value);
  }

  function renderWorksiteSupervisorOptions(supervisors, selectedSupervisorIds) {
    const $modal = $("#worksite-supervisors-modal");

    const $options = $modal.find("[data-worksite-supervisors-options]");

    const $empty = $modal.find("[data-worksite-supervisors-empty]");

    $options.empty();

    const normalizedSelectedIds = Array.isArray(selectedSupervisorIds)
      ? selectedSupervisorIds.map(String)
      : [];

    if (!Array.isArray(supervisors) || supervisors.length === 0) {
      $empty.removeClass("hidden");

      return;
    }

    $empty.addClass("hidden");

    supervisors.forEach(function (supervisor) {
      const supervisorId = String(supervisor.id || "");

      if (!supervisorId) {
        return;
      }

      const supervisorName = escapeWorksiteSupervisorHtml(
        supervisor.name || t("js.supervisors.supervisor"),
      );

      const position = escapeWorksiteSupervisorHtml(supervisor.position || "");

      const hasUserAccount = isCheckedValue(supervisor.has_user_account);

      const isSelected = normalizedSelectedIds.includes(supervisorId);

      const accountBadge = hasUserAccount
        ? `
          <span class="inline-flex rounded-full bg-emerald-100 px-2.5 py-1 text-[11px] font-semibold text-emerald-700">
            ${t("js.supervisors.login_connected")}
          </span>
        `
        : `
          <span class="inline-flex rounded-full bg-amber-100 px-2.5 py-1 text-[11px] font-semibold text-amber-700">
            ${t("js.supervisors.no_login_account")}
          </span>
        `;

      const positionHtml = position
        ? `
          <div class="mt-1 text-xs text-slate-500">
            ${position}
          </div>
        `
        : "";

      const $option = $(`
        <label class="flex cursor-pointer items-start gap-4 rounded-xl border border-slate-200 bg-white p-4 transition hover:border-indigo-300 hover:bg-indigo-50/40">

          <span class="relative mt-0.5 inline-flex h-6 w-11 shrink-0">

            <input
              type="checkbox"
              name="supervisor_ids[]"
              value="${supervisorId}"
              class="peer sr-only">

            <span
              data-worksite-supervisor-track
              aria-hidden="true"
              class="absolute inset-0 rounded-full bg-slate-300 transition-colors duration-200">
            </span>

            <span
              data-worksite-supervisor-thumb
              aria-hidden="true"
              class="absolute left-1 top-1 h-4 w-4 rounded-full bg-white shadow-sm transition-transform duration-200">
            </span>

          </span>

          <span class="min-w-0 flex-1">

            <span class="flex flex-wrap items-center gap-2">

              <span class="font-semibold text-slate-900">
                ${supervisorName}
              </span>

              ${accountBadge}

            </span>

            ${positionHtml}

          </span>

        </label>
      `);

      const $checkbox = $option.find('[name="supervisor_ids[]"]');

      $checkbox.prop("checked", isSelected);

      updateWorksiteSupervisorSwitch($checkbox);

      $options.append($option);
    });
  }

  function updateWorksiteSupervisorSwitch($checkbox) {
    const isChecked = $checkbox.is(":checked");

    const $switch = $checkbox.parent();

    const $track = $switch.find("[data-worksite-supervisor-track]");

    const $thumb = $switch.find("[data-worksite-supervisor-thumb]");

    $track
      .toggleClass("bg-slate-300", !isChecked)
      .toggleClass("bg-indigo-600", isChecked);

    $thumb.css("transform", isChecked ? "translateX(20px)" : "");
  }

  $(document).on(
    "change",
    '#aevon-worksite-supervisors-form [name="supervisor_ids[]"]',
    function () {
      updateWorksiteSupervisorSwitch($(this));
    },
  );

  function renderOtherWorksiteSupervisorGroups(groups, currentCompanyId) {
    const $modal = $("#worksite-supervisors-modal");

    const $section = $modal.find(
      "[data-worksite-supervisors-other-groups-section]",
    );

    const $container = $modal.find("[data-worksite-supervisors-other-groups]");

    $container.empty();

    if (!Array.isArray(groups)) {
      $section.addClass("hidden");

      return;
    }

    const otherGroups = groups.filter(function (group) {
      return String(group.company_id || "") !== String(currentCompanyId || "");
    });

    if (!otherGroups.length) {
      $section.addClass("hidden");

      return;
    }

    otherGroups.forEach(function (group) {
      const companyName = escapeWorksiteSupervisorHtml(
        group.company_name || t("js.supervisors.company"),
      );

      const workers = Array.isArray(group.workers) ? group.workers : [];

      const workerItems = workers
        .map(function (worker) {
          const workerName = escapeWorksiteSupervisorHtml(
            worker.name || t("js.supervisors.supervisor"),
          );

          return `
            <div class="inline-flex items-center gap-2 text-sm font-semibold text-indigo-700">

              <i
                data-feather="award"
                class="h-4 w-4 shrink-0">
              </i>

              <span>
                ${workerName}
              </span>

            </div>
          `;
        })
        .join("");

      if (!workerItems) {
        return;
      }

      $container.append(`
        <div class="rounded-xl border border-slate-200 bg-slate-50 p-4">

          <div class="text-xs font-semibold uppercase tracking-wide text-slate-400">
            ${companyName}
          </div>

          <div class="mt-3 grid gap-2">
            ${workerItems}
          </div>

        </div>
      `);
    });

    if (!$container.children().length) {
      $section.addClass("hidden");

      return;
    }

    $section.removeClass("hidden");

    if (window.feather && typeof window.feather.replace === "function") {
      window.feather.replace();
    }
  }

  function loadWorksiteSupervisors(worksiteId) {
    const $modal = $("#worksite-supervisors-modal");

    const $form = $("#aevon-worksite-supervisors-form");

    $.ajax({
      url: AevonWorkspace.ajaxUrl,
      method: "POST",

      data: {
        action: "aevon_workspace_get_worksite_supervisors",

        nonce: AevonWorkspace.nonce,

        worksite_id: worksiteId,
      },

      success: function (response) {
        if (!response || !response.success || !response.data) {
          const message = getResponseMessage(
            response,
            t("js.supervisors.load_error"),
          );

          $modal.find("[data-worksite-supervisors-loading]").addClass("hidden");

          $modal.find("[data-worksite-supervisors-content]").addClass("hidden");

          $modal
            .find("[data-worksite-supervisors-error-message]")
            .text(message);

          $modal
            .find("[data-worksite-supervisors-error]")
            .removeClass("hidden");

          return;
        }

        const data = response.data;

        const worksite = data.worksite || {};

        const company = data.company || {};

        const availableSupervisors = Array.isArray(data.available_supervisors)
          ? data.available_supervisors
          : [];

        const selectedSupervisorIds = Array.isArray(
          data.selected_supervisor_ids,
        )
          ? data.selected_supervisor_ids
          : [];

        const visibleGroups = Array.isArray(data.visible_groups)
          ? data.visible_groups
          : [];

        $form.find('[name="worksite_id"]').val(worksite.id || worksiteId);

        $modal.find("[data-worksite-supervisors-modal-title]").text(
          worksite.name
            ? t("js.supervisors.title_with_worksite", {
                worksite: worksite.name,
              })
            : t("js.supervisors.title"),
        );

        $modal
          .find("[data-worksite-supervisors-worksite-name]")
          .text(worksite.name || "—");

        $modal
          .find("[data-worksite-supervisors-company-name]")
          .text(company.name || "—");

        $modal
          .find("[data-worksite-supervisors-company-type]")
          .text(
            isCheckedValue(company.is_owner)
              ? t("js.supervisors.worksite_owner")
              : t("js.supervisors.partner_company"),
          );

        renderWorksiteSupervisorOptions(
          availableSupervisors,
          selectedSupervisorIds,
        );

        renderOtherWorksiteSupervisorGroups(visibleGroups, company.id);

        $modal.find("[data-worksite-supervisors-loading]").addClass("hidden");

        $modal.find("[data-worksite-supervisors-error]").addClass("hidden");

        $modal
          .find("[data-worksite-supervisors-content]")
          .removeClass("hidden");

        $modal.find("[data-save-worksite-supervisors]").prop("disabled", false);

        if (window.feather && typeof window.feather.replace === "function") {
          window.feather.replace();
        }
      },

      error: function (xhr) {
        const message = getAjaxErrorMessage(
          xhr,
          t("js.supervisors.load_error"),
        );

        $modal.find("[data-worksite-supervisors-loading]").addClass("hidden");

        $modal.find("[data-worksite-supervisors-content]").addClass("hidden");

        $modal.find("[data-worksite-supervisors-error-message]").text(message);

        $modal.find("[data-worksite-supervisors-error]").removeClass("hidden");
      },
    });
  }

  $(document).on(
    "click",
    "[data-open-worksite-supervisors-modal]",
    function () {
      const worksiteId = Number($(this).attr("data-worksite-id") || 0);

      if (!worksiteId) {
        showToast(t("js.worksite.not_found"));

        return;
      }

      resetWorksiteSupervisorsModal();

      openModal("#worksite-supervisors-modal");

      loadWorksiteSupervisors(worksiteId);
    },
  );

  $(document).on(
    "click",
    "[data-close-worksite-supervisors-modal]",
    function () {
      closeModal("#worksite-supervisors-modal");
    },
  );

  $(document).on("click", "#worksite-supervisors-modal", function (event) {
    if (event.target !== this) {
      return;
    }

    closeModal("#worksite-supervisors-modal");
  });

  $("#aevon-worksite-supervisors-form").on("submit", function (event) {
    event.preventDefault();

    const $form = $(this);

    const $button = $form.find("[data-save-worksite-supervisors]");

    const $label = $form.find("[data-worksite-supervisors-submit-label]");

    const worksiteId = Number($form.find('[name="worksite_id"]').val() || 0);

    if (!worksiteId) {
      showToast(t("js.worksite.not_found"));

      return;
    }

    const supervisorIds = $form
      .find('[name="supervisor_ids[]"]:checked')
      .map(function () {
        return String($(this).val() || "");
      })
      .get()
      .filter(Boolean);

    $button.prop("disabled", true).addClass("opacity-50");

    $label.text(t("js.common.saving"));

    $.ajax({
      url: AevonWorkspace.ajaxUrl,
      method: "POST",

      data: {
        action: "aevon_workspace_save_worksite_supervisors",

        nonce: AevonWorkspace.nonce,

        worksite_id: worksiteId,

        supervisor_ids: supervisorIds,
      },

      success: function (response) {
        if (!response || !response.success) {
          showToast(
            getResponseMessage(response, t("js.supervisors.save_error")),
          );

          return;
        }

        showToast(
          getResponseMessage(response, t("js.supervisors.updated")),
          "success",
        );

        closeModal("#worksite-supervisors-modal");

        window.setTimeout(function () {
          window.location.reload();
        }, 600);
      },

      error: function (xhr) {
        showToast(getAjaxErrorMessage(xhr, t("js.supervisors.save_error")));
      },

      complete: function () {
        $button.prop("disabled", false).removeClass("opacity-50");

        $label.text(t("js.supervisors.save"));
      },
    });
  });

  /*
  |--------------------------------------------------------------------------
  | TABLE SEARCH
  |--------------------------------------------------------------------------
  */

  $(document).on("input", "[data-table-search]", function () {
    const target = $(this).data("table-search");

    const query = String($(this).val() || "").toLowerCase();

    $('[data-search-row="' + target + '"]').each(function () {
      const text = String($(this).data("search-text") || "").toLowerCase();

      $(this).toggle(!query || text.includes(query));
    });
  });

  /*
  |--------------------------------------------------------------------------
  | TABLE STATUS FILTER
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-table-filter]", function () {
    const target = $(this).data("table-filter");

    const status = $(this).data("filter-status");

    $('[data-table-filter="' + target + '"]')
      .removeClass("bg-slate-900 text-white")
      .addClass("bg-slate-100 text-slate-700");

    $(this)
      .removeClass("bg-slate-100 text-slate-700")
      .addClass("bg-slate-900 text-white");

    $('[data-search-row="' + target + '"]').each(function () {
      const rowStatus = $(this).data("filter-status");

      $(this).toggle(status === "all" || rowStatus === status);
    });
  });

  /*
  |--------------------------------------------------------------------------
  | ACCOMMODATION MODAL — OPEN AND CLOSE
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-open-accommodation-modal]", function () {
    const $form = $("#aevon-accommodation-form");

    if ($form[0]) {
      $form[0].reset();
    }

    openModal("#accommodation-modal");
  });

  $(document).on("click", "[data-close-accommodation-modal]", function () {
    closeModal("#accommodation-modal");
  });

  /*
  |--------------------------------------------------------------------------
  | ACCOMMODATION FORM — CREATE
  |--------------------------------------------------------------------------
  */

  $("#aevon-accommodation-form").on("submit", function (event) {
    event.preventDefault();

    const $form = $(this);

    const $button = $form.find('button[type="submit"]');

    const originalButtonHtml = $button.html();

    $button.prop("disabled", true).addClass("cursor-not-allowed opacity-60");

    $.ajax({
      url: AevonWorkspace.ajaxUrl,
      method: "POST",

      data:
        $form.serialize() +
        "&action=aevon_workspace_create_accommodation" +
        "&nonce=" +
        encodeURIComponent(AevonWorkspace.nonce),

      success: function (response) {
        if (!response.success) {
          showToast(
            getResponseMessage(response, t("js.accommodation.create_error")),
          );

          return;
        }

        const accommodation = response.data.accommodation;

        const $select = $('#aevon-assignment-form [name="accommodation_id"]');

        if (accommodation && accommodation.id) {
          const optionExists =
            $select.find('option[value="' + accommodation.id + '"]').length > 0;

          if (!optionExists) {
            $select.append(
              $("<option>", {
                value: accommodation.id,
                text: accommodation.title || t("js.accommodation.label"),
              }),
            );
          }

          $select.val(String(accommodation.id)).trigger("change");
        }

        closeModal("#accommodation-modal");

        if ($form[0]) {
          $form[0].reset();
        }

        showToast(
          getResponseMessage(response, t("js.accommodation.created")),
          "success",
        );
      },

      error: function (xhr) {
        showToast(getAjaxErrorMessage(xhr, t("js.accommodation.create_error")));
      },

      complete: function () {
        $button
          .prop("disabled", false)
          .removeClass("cursor-not-allowed opacity-60")
          .html(originalButtonHtml);
      },
    });
  });

  /*
  |--------------------------------------------------------------------------
  | TIMESHEET MODAL — OPEN AND CLOSE
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-open-timesheet-modal]", function () {
    const assignmentId = $(this).attr("data-assignment-id");

    const $form = $("#aevon-timesheet-form");

    if ($form[0]) {
      $form[0].reset();
    }

    $form.find('[name="assignment_id"]').val(assignmentId || "");

    openModal("#timesheet-modal");
  });

  $(document).on("click", "[data-close-timesheet-modal]", function () {
    closeModal("#timesheet-modal");
  });

  /*
  |--------------------------------------------------------------------------
  | TIMESHEET FORM — UPLOAD
  |--------------------------------------------------------------------------
  */

  $("#aevon-timesheet-form").on("submit", function (event) {
    event.preventDefault();

    const $form = $(this);

    const $button = $form.find('button[type="submit"]');

    const originalButtonHtml = $button.html();

    const formData = new FormData(this);

    formData.append("action", "aevon_workspace_create_timesheet");

    formData.append("nonce", AevonWorkspace.nonce);

    $button.prop("disabled", true).addClass("cursor-not-allowed opacity-60")
      .html(`
        <span class="inline-flex items-center justify-center gap-2">
          <svg
            class="h-4 w-4 animate-spin"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true">

            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4">
            </circle>

            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z">
            </path>
          </svg>

          ${t("js.timesheet.uploading")}
        </span>
      `);

    $.ajax({
      url: AevonWorkspace.ajaxUrl,
      method: "POST",
      data: formData,
      processData: false,
      contentType: false,

      success: function (response) {
        if (!response.success) {
          showToast(
            getResponseMessage(response, t("js.timesheet.upload_error")),
          );

          return;
        }

        closeModal("#timesheet-modal");

        showToast(
          getResponseMessage(response, t("js.timesheet.uploaded")),
          "success",
        );

        setTimeout(function () {
          window.location.reload();
        }, 700);
      },

      error: function (xhr) {
        showToast(
          getAjaxErrorMessage(xhr, t("js.timesheet.upload_retry_error")),
        );
      },

      complete: function () {
        $button
          .prop("disabled", false)
          .removeClass("cursor-not-allowed opacity-60")
          .html(originalButtonHtml);
      },
    });
  });

  /*
  |--------------------------------------------------------------------------
  | DESKTOP SIDEBAR COLLAPSE
  |--------------------------------------------------------------------------
  */

  function setSidebarState(collapsed) {
    const $sidebar = $("#workspace-sidebar");

    const $content = $("#workspace-content");

    const $labels = $(".workspace-nav-label");

    const $navItems = $(".workspace-nav-item");

    const $toggleIcon = $("#workspace-sidebar-toggle-icon");

    const $headings = $("[data-sidebar-heading]");

    if (collapsed) {
      document.documentElement.classList.add("aevon-sidebar-collapsed");

      $sidebar.removeClass("w-72").addClass("w-20");

      $content.removeClass("lg:pl-72").addClass("lg:pl-20");

      $labels.addClass("hidden");

      $headings.addClass("hidden");

      $navItems.removeClass("gap-3 px-4").addClass("justify-center px-0");

      $toggleIcon.attr("data-feather", "chevron-right");
    } else {
      document.documentElement.classList.remove("aevon-sidebar-collapsed");

      $sidebar.removeClass("w-20").addClass("w-72");

      $content.removeClass("lg:pl-20").addClass("lg:pl-72");

      $labels.removeClass("hidden");

      $headings.removeClass("hidden");

      $navItems.removeClass("justify-center px-0").addClass("gap-3 px-4");

      $toggleIcon.attr("data-feather", "chevron-left");
    }

    localStorage.setItem("aevonSidebarCollapsed", collapsed ? "1" : "0");

    if (typeof feather !== "undefined") {
      feather.replace();
    }
  }

  setSidebarState(localStorage.getItem("aevonSidebarCollapsed") === "1");

  $("#workspace-sidebar-toggle").on("click", function () {
    const isCollapsed = $("#workspace-sidebar").hasClass("w-20");

    setSidebarState(!isCollapsed);
  });

  /*
  |--------------------------------------------------------------------------
  | PROFILE FORM
  |--------------------------------------------------------------------------
  */

  $("#aevon-profile-form").on("submit", function (event) {
    event.preventDefault();

    const $form = $(this);

    const $button = $form.find("button[type='submit']");

    const firstName = String(
      $form.find('[name="first_name"]').val() || "",
    ).trim();

    const lastName = String(
      $form.find('[name="last_name"]').val() || "",
    ).trim();

    const displayName = String(
      $form.find('[name="display_name"]').val() || "",
    ).trim();

    const email = String($form.find('[name="email"]').val() || "").trim();

    if (!displayName) {
      showToast(t("js.profile.display_name_required"), "error");

      return;
    }

    if (!email) {
      showToast(t("js.profile.email_required"), "error");

      return;
    }

    $button.prop("disabled", true).addClass("opacity-50");

    $.ajax({
      url: AevonWorkspace.ajaxUrl,
      method: "POST",

      data: {
        action: "aevon_workspace_update_profile",
        nonce: AevonWorkspace.nonce,
        first_name: firstName,
        last_name: lastName,
        display_name: displayName,
        email: email,
      },

      success: function (response) {
        if (!response.success) {
          showToast(
            getResponseMessage(response, t("js.profile.update_error")),
            "error",
          );

          return;
        }

        showToast(
          getResponseMessage(response, t("js.profile.updated")),
          "success",
        );

        const updatedDisplayName =
          response.data &&
          response.data.profile &&
          response.data.profile.display_name
            ? response.data.profile.display_name
            : displayName;

        const $headerName = $("[data-workspace-current-user-name]");

        if ($headerName.length) {
          $headerName.text(updatedDisplayName);
        }
      },

      error: function (xhr) {
        showToast(
          getAjaxErrorMessage(xhr, t("js.profile.update_error")),
          "error",
        );
      },

      complete: function () {
        $button.prop("disabled", false).removeClass("opacity-50");
      },
    });
  });

  /*
  |--------------------------------------------------------------------------
  | PASSWORD FORM
  |--------------------------------------------------------------------------
  */

  $("#aevon-password-form").on("submit", function (event) {
    event.preventDefault();

    const $form = $(this);

    const $button = $form.find("button[type='submit']");

    const currentPassword = String(
      $form.find('[name="current_password"]').val() || "",
    );

    const newPassword = String($form.find('[name="new_password"]').val() || "");

    const confirmPassword = String(
      $form.find('[name="confirm_password"]').val() || "",
    );

    if (!currentPassword) {
      showToast(t("js.password.current_required"), "error");

      return;
    }

    if (!newPassword) {
      showToast(t("js.password.new_required"), "error");

      return;
    }

    if (newPassword !== confirmPassword) {
      showToast(t("js.password.not_matching"), "error");

      return;
    }

    $button.prop("disabled", true).addClass("opacity-50");

    $.ajax({
      url: AevonWorkspace.ajaxUrl,
      method: "POST",

      data: {
        action: "aevon_workspace_change_password",
        nonce: AevonWorkspace.nonce,
        current_password: currentPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      },

      success: function (response) {
        if (!response.success) {
          showToast(
            getResponseMessage(response, t("js.password.change_error")),
            "error",
          );

          return;
        }

        if ($form[0]) {
          $form[0].reset();
        }

        showToast(
          getResponseMessage(response, t("js.password.changed")),
          "success",
        );
      },

      error: function (xhr) {
        showToast(
          getAjaxErrorMessage(xhr, t("js.password.change_error")),
          "error",
        );
      },

      complete: function () {
        $button.prop("disabled", false).removeClass("opacity-50");
      },
    });
  });

  /*
  |--------------------------------------------------------------------------
  | WORKER ASSIGNMENT PROGRESS
  |--------------------------------------------------------------------------
  */

  function submitWorkerAssignmentProgress(
    $button,
    action,
    loadingLabel,
    fallbackError,
  ) {
    const assignmentId = Number($button.attr("data-assignment-id") || 0);

    if (!assignmentId) {
      showToast(t("js.assignment.not_found"), "error");

      return;
    }

    const $label = $button.find("[data-assignment-progress-button-label]");

    const originalLabel = $label.length ? $label.text().trim() : "";

    $button.prop("disabled", true).addClass("opacity-50");

    if ($label.length) {
      $label.text(loadingLabel);
    }

    $.ajax({
      url: AevonWorkspace.ajaxUrl,
      method: "POST",

      data: {
        action: action,
        nonce: AevonWorkspace.nonce,
        assignment_id: assignmentId,
      },

      success: function (response) {
        if (!response || !response.success) {
          showToast(getResponseMessage(response, fallbackError), "error");

          return;
        }

        showToast(
          getResponseMessage(response, t("js.assignment.updated")),
          "success",
        );

        window.setTimeout(function () {
          window.location.reload();
        }, 800);
      },

      error: function (xhr) {
        showToast(getAjaxErrorMessage(xhr, fallbackError), "error");
      },

      complete: function () {
        $button.prop("disabled", false).removeClass("opacity-50");

        if ($label.length) {
          $label.text(originalLabel);
        }
      },
    });
  }

  /*
  |--------------------------------------------------------------------------
  | START ASSIGNMENT
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-worker-start-assignment]", function () {
    submitWorkerAssignmentProgress(
      $(this),
      "aevon_workspace_worker_start_assignment",
      t("js.assignment.starting"),
      t("js.assignment.start_error"),
    );
  });

  /*
  |--------------------------------------------------------------------------
  | CONFIRM MODAL
  |--------------------------------------------------------------------------
  */

  window.openConfirmModal = function (options = {}) {
    const $modal = $("#confirm-modal");

    if (!$modal.length) {
      showToast(t("js.confirm.unavailable"), "error");

      return;
    }

    const title = options.title || t("js.confirm.title");

    const message = options.message || t("js.confirm.message");

    const confirmLabel = options.confirmLabel || t("js.confirm.confirm");

    const confirmClass =
      options.confirmClass || "bg-brand-primary text-white hover:opacity-90";

    const onConfirm =
      typeof options.onConfirm === "function"
        ? options.onConfirm
        : function () {};

    const $confirmButton = $modal.find("[data-confirm-modal-confirm]");

    $modal.find("[data-confirm-modal-title]").text(title);

    $modal.find("[data-confirm-modal-message]").text(message);

    $confirmButton
      .removeClass(
        "bg-brand-primary bg-red-600 hover:bg-red-700 hover:opacity-90",
      )
      .addClass(confirmClass)
      .text(confirmLabel);

    $confirmButton
      .off("click.aevonConfirm")
      .one("click.aevonConfirm", function () {
        window.closeConfirmModal();

        onConfirm();
      });

    $modal.removeClass("hidden").addClass("flex");

    $("body").addClass("overflow-hidden");

    if (window.feather && typeof window.feather.replace === "function") {
      window.feather.replace();
    }
  };

  window.closeConfirmModal = function () {
    const $modal = $("#confirm-modal");

    $modal.addClass("hidden").removeClass("flex");

    $("body").removeClass("overflow-hidden");

    $modal.find("[data-confirm-modal-confirm]").off("click.aevonConfirm");
  };

  $(document).on("click", "[data-confirm-modal-close]", function () {
    window.closeConfirmModal();
  });

  $(document).on("click", "#confirm-modal", function (event) {
    if (event.target === this) {
      window.closeConfirmModal();
    }
  });

  $(document).on("keydown", function (event) {
    if (event.key === "Escape" && !$("#confirm-modal").hasClass("hidden")) {
      window.closeConfirmModal();
    }
  });

  /*
  |--------------------------------------------------------------------------
  | COMPLETE ASSIGNMENT
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-worker-complete-assignment]", function () {
    const $button = $(this);

    window.openConfirmModal({
      title: t("js.assignment.complete_title"),

      message: t("js.assignment.complete_message"),

      confirmLabel: t("js.assignment.complete_title"),

      confirmClass: "bg-red-600 text-white hover:bg-red-700",

      onConfirm: function () {
        submitWorkerAssignmentProgress(
          $button,
          "aevon_workspace_worker_complete_assignment",
          t("js.assignment.completing"),
          t("js.assignment.complete_error"),
        );
      },
    });
  });

  /*
  |--------------------------------------------------------------------------
  | ASSIGNMENT PROGRESS MODAL
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-open-assignment-progress-modal]", function () {
    const $button = $(this);

    const $modal = $("#assignment-progress-modal");

    const $form = $("#aevon-assignment-progress-form");

    $form
      .find('[name="assignment_id"]')
      .val($button.attr("data-assignment-id") || "");

    $form
      .find('[name="progress_status"]')
      .val($button.attr("data-progress-status") || "pending");

    $form
      .find('[name="progress_note"]')
      .val($button.attr("data-progress-note") || "");

    $modal.removeClass("hidden").addClass("flex");

    $("body").addClass("overflow-hidden");
  });

  function closeAssignmentProgressModal() {
    $("#assignment-progress-modal").addClass("hidden").removeClass("flex");

    $("body").removeClass("overflow-hidden");
  }

  $(document).on(
    "click",
    "[data-close-assignment-progress-modal]",
    function () {
      closeAssignmentProgressModal();
    },
  );

  /*
  |--------------------------------------------------------------------------
  | SAVE ASSIGNMENT PROGRESS
  |--------------------------------------------------------------------------
  */

  $("#aevon-assignment-progress-form").on("submit", function (event) {
    event.preventDefault();

    const $form = $(this);

    const $button = $form.find("button[type='submit']");

    $button.prop("disabled", true).addClass("opacity-50");

    $.ajax({
      url: AevonWorkspace.ajaxUrl,
      method: "POST",

      data: {
        action: "aevon_workspace_admin_update_assignment_progress",

        nonce: AevonWorkspace.nonce,

        assignment_id: $form.find('[name="assignment_id"]').val(),

        progress_status: $form.find('[name="progress_status"]').val(),

        progress_note: $form.find('[name="progress_note"]').val(),
      },

      success: function (response) {
        if (!response.success) {
          showToast(
            getResponseMessage(
              response,
              t("js.assignment_progress.update_error"),
            ),
            "error",
          );

          return;
        }

        closeAssignmentProgressModal();

        showToast(
          getResponseMessage(response, t("js.assignment_progress.updated")),
          "success",
        );

        window.setTimeout(function () {
          window.location.reload();
        }, 700);
      },

      error: function (xhr) {
        showToast(
          getAjaxErrorMessage(xhr, t("js.assignment_progress.update_error")),
          "error",
        );
      },

      complete: function () {
        $button.prop("disabled", false).removeClass("opacity-50");
      },
    });
  });
});
